import { createAction, props } from '@ngrx/store'
import { User } from '../../models/user'

export const loginRequested = createAction('[Login] Login Request', props<{ userName: string; password: string }>())
export const loginFailed = createAction('[Login] Login Failure', props<{ error: string }>())
export const loginSucceeded = createAction('[Login] Login Success', props<{ user: User }>())
export const passwordChangeRequired = createAction('[Login] Login Password change required', props<{ user: User }>())
export const logoutRequested = createAction(
  '[Logout] Logout Requested',
  props<{ sendLogoutRequestToServer: boolean }>()
)
export const logoutSucceeded = createAction('[Logout] Logout Success')
export const validateTokenRequested = createAction('[AppModule] Token validation requested')
export const validateTokenSucceeded = createAction('[Auth] Token validation succeeded', props<{ user: User }>())
export const validateTokenFailed = createAction('[Auth] Token validation failed')
export const validateTokenUnnecessary = createAction('[Auth] Token validation not needed (No token available)')
export const prolongTokenRequested = createAction('[AppModule] Token prolonging requested')
export const prolongTokenSucceeded = createAction('[Auth] Token prolonging succeeded', props<{ user: User }>())
export const prolongTokenFailed = createAction('[Auth] Token prolonging failed')
export const prolongTokenNotPossible = createAction('[Auth] Token prolonging not possible (No token available)')
export const changePwRequested = createAction('[Auth] Pw change requested', props<{ oldPw: string; newPw: string }>())
export const changePwSucceeded = createAction('[Auth] Pw change succeeded')
export const changePwFailed = createAction('[Auth] Pw change failed') //error details?
export const reactivateTokenRequested = createAction(
  '[Auth] Reactivate token',
  props<{ userName: string; password: string }>()
)
export const reactivateTokenSucceeded = createAction('[Auth] Reactivating token succeeded', props<{ user: User }>())
export const reactivateTokenFailed = createAction('[Auth] Reactivating token failed', props<{ error: string }>())
